import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	byKeyword: {
		id: 'inactive-projects-directory-base.projects-table.body.cells.date-user.by-keyword',
		defaultMessage: 'by',
		description: 'Word used to join date and user items in date-user cell',
	},
});
